{
  "content": {
    "background": {
      "$type": "color",
      "$value": "{surface.0}"
    },
    "color": {
      "$type": "color",
      "$value": "{text.color}"
    },
    "hover": {
      "background": {
        "$type": "color",
        "$value": "{colours.interaction-states.hover.background-hover}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.hover.color}"
      }
    },
    "border": {
      "color": {
        "$type": "color",
        "$value": "{colours.basic.stroke-subtle}"
      }
    }
  },
  "form": {
    "field": {
      "background": {
        "$type": "color",
        "$value": "{colours.basic.background}"
      },
      "color": {
        "$type": "color",
        "$value": "{colours.basic.text}"
      },
      "disabled": {
        "background": {
          "$type": "color",
          "$value": "{colours.interaction-states.disabled.background-disabled}"
        },
        "color": {
          "$type": "color",
          "$value": "{colours.basic.text}"
        }
      },
      "filled": {
        "background": {
          "$type": "color",
          "$value": "{surface.50}"
        },
        "focus": {
          "background": {
            "$type": "color",
            "$value": "{surface.50}"
          }
        },
        "hover": {
          "background": {
            "$type": "color",
            "$value": "{surface.50}"
          }
        }
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{colours.basic.stroke}"
        }
      },
      "hover": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{primary.hover.color}"
          }
        }
      },
      "focus": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.basic.stroke}"
          }
        }
      },
      "invalid": {
        "border": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.destructive.standard}"
          }
        },
        "placeholder": {
          "color": {
            "$type": "color",
            "$value": "{colours.functional.destructive.standard}"
          }
        }
      },
      "placeholder": {
        "color": {
          "$type": "color",
          "$value": "{colours.basic.text-recessive}"
        }
      },
      "float": {
        "label": {
          "color": {
            "$type": "color",
            "$value": "{surface.500}"
          },
          "focus": {
            "color": {
              "$type": "color",
              "$value": "{surface.500}"
            }
          },
          "invalid": {
            "color": {
              "$type": "color",
              "$value": "{form.field.invalid.placeholder.color}"
            }
          },
          "active": {
            "color": {
              "$type": "color",
              "$value": "{surface.500}"
            }
          }
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{colours.basic.text-recessive}"
        }
      }
    }
  },
  "highlight": {
    "background": {
      "$type": "color",
      "$value": "{surface.200}"
    },
    "color": {
      "$type": "color",
      "$value": "{text.color}"
    },
    "focus": {
      "background": {
        "$type": "color",
        "$value": "{primary.100}"
      },
      "color": {
        "$type": "color",
        "$value": "{primary.800}"
      }
    }
  },
  "list": {
    "option": {
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{surface.100}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.hover.color}"
        }
      },
      "selected": {
        "background": {
          "$type": "color",
          "$value": "{highlight.background}"
        },
        "color": {
          "$type": "color",
          "$value": "{highlight.color}"
        },
        "focus": {
          "background": {
            "$type": "color",
            "$value": "{highlight.focus.background}"
          },
          "color": {
            "$type": "color",
            "$value": "{highlight.focus.color}"
          }
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{surface.400}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{surface.500}"
          }
        }
      },
      "group": {
        "background": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        },
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        }
      }
    }
  },
  "mask": {
    "background": {
      "$type": "color",
      "$value": "rgba(0, 0, 0, 0.4000)"
    },
    "color": {
      "$type": "color",
      "$value": "{surface.200}"
    }
  },
  "navigation": {
    "item": {
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "focus": {
        "background": {
          "$type": "color",
          "$value": "{surface.100}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.hover.color}"
        }
      },
      "active": {
        "background": {
          "$type": "color",
          "$value": "{surface.100}"
        },
        "color": {
          "$type": "color",
          "$value": "{text.hover.color}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{surface.950}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{surface.950}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{surface.950}"
          }
        }
      }
    },
    "submenu": {
      "label": {
        "background": {
          "$type": "color",
          "$value": "rgba(0, 0, 0, 0.0000)"
        },
        "color": {
          "$type": "color",
          "$value": "{text.muted.color}"
        }
      },
      "icon": {
        "color": {
          "$type": "color",
          "$value": "{surface.400}"
        },
        "focus": {
          "color": {
            "$type": "color",
            "$value": "{surface.500}"
          }
        },
        "active": {
          "color": {
            "$type": "color",
            "$value": "{surface.500}"
          }
        }
      }
    }
  },
  "overlay": {
    "select": {
      "background": {
        "$type": "color",
        "$value": "{surface.0}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.200}"
        }
      }
    },
    "popover": {
      "background": {
        "$type": "color",
        "$value": "{surface.0}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.200}"
        }
      }
    },
    "modal": {
      "background": {
        "$type": "color",
        "$value": "{surface.0}"
      },
      "color": {
        "$type": "color",
        "$value": "{text.color}"
      },
      "border": {
        "color": {
          "$type": "color",
          "$value": "{surface.400}"
        }
      }
    }
  },
  "primary": {
    "color": {
      "$type": "color",
      "$value": "{primary.500}"
    },
    "contrast": {
      "color": {
        "$type": "color",
        "$value": "#ffffff"
      }
    },
    "hover": {
      "color": {
        "$type": "color",
        "$value": "{primary.600}"
      }
    },
    "active": {
      "color": {
        "$type": "color",
        "$value": "{primary.700}"
      }
    }
  },
  "surface": {
    "0": {
      "$type": "color",
      "$value": "{ods.core-colours.base.white}"
    },
    "50": {
      "$type": "color",
      "$value": "{slate.50}"
    },
    "100": {
      "$type": "color",
      "$value": "{ods.core-colours.grey.100}"
    },
    "200": {
      "$type": "color",
      "$value": "{ods.core-colours.grey.200}"
    },
    "300": {
      "$type": "color",
      "$value": "{ods.core-colours.grey.300}"
    },
    "400": {
      "$type": "color",
      "$value": "{ods.core-colours.grey.400}"
    },
    "500": {
      "$type": "color",
      "$value": "{ods.core-colours.grey.500}"
    },
    "600": {
      "$type": "color",
      "$value": "{ods.core-colours.grey.600}"
    },
    "700": {
      "$type": "color",
      "$value": "{ods.core-colours.grey.700}"
    },
    "800": {
      "$type": "color",
      "$value": "{ods.core-colours.grey.800}"
    },
    "900": {
      "$type": "color",
      "$value": "{ods.core-colours.grey.900}"
    },
    "950": {
      "$type": "color",
      "$value": "{ods.core-colours.base.black}"
    }
  },
  "text": {
    "color": {
      "$type": "color",
      "$value": "{colours.basic.text}"
    },
    "hover": {
      "color": {
        "$type": "color",
        "$value": "{colours.interaction-states.hover.text-hover}"
      },
      "muted": {
        "color": {
          "$type": "color",
          "$value": "{colours.interaction-states.hover.text-hover}"
        }
      }
    },
    "muted": {
      "color": {
        "$type": "color",
        "$value": "{colours.basic.text-recessive}"
      }
    }
  }
}
